var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNotification24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_notification24x24",
    transform: "translate(-6 -4.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alarm",
    transform: "translate(6 4.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26567",
    "data-name": "Group 26567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26566",
    "data-name": "Group 26566",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46942",
    "data-name": "Path 46942",
    d: "M167.389,375.26a1.993,1.993,0,0,0,2.055-1.927h-4.109a1.993,1.993,0,0,0,2.055,1.927Z",
    transform: "translate(-159.389 -357.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46943",
    "data-name": "Path 46943",
    d: "M51.333,12.358V7.781A5.639,5.639,0,0,0,46.833,2V1.374a1.505,1.505,0,0,0-3,0V2a5.639,5.639,0,0,0-4.5,5.785v4.577l-2,1.831V15.1h16v-.911Z",
    transform: "translate(-37.333 .005)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNotification24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_notification24x24.9461ec7595f1b2fd95ee80fa0229549d.svg";